import React, { useState } from 'react';

const NavigationButtons = ({ 
  onNext, 
  nextLabel = 'Continuar', 
  disableNext = false, 
  isLoading = false 
}) => {
  const [isButtonProcessing, setIsButtonProcessing] = useState(false);

  const handleNextClick = async (e) => {
    // Prevenir múltiples clics en el botón
    if (isButtonProcessing || isLoading) {
      e.preventDefault();
      return;
    }

    setIsButtonProcessing(true);
    
    try {
      if (onNext) {
        await onNext();
      }
    } catch (error) {
      console.error('Error en NavigationButtons:', error);
    } finally {
      setIsButtonProcessing(false);
    }
  };

  return (
    <div className="d-flex justify-content-end mt-4">
      {onNext && (
        <button 
          className="btn btn-primary" 
          type="button" 
          onClick={handleNextClick} 
          disabled={disableNext || isLoading || isButtonProcessing}
        >
          {(isLoading || isButtonProcessing) && (
            <span 
              className="spinner-border spinner-border-sm me-2" 
              role="status" 
              aria-hidden="true"
            ></span>
          )}
          {nextLabel}<i className="bi bi-arrow-right ms-2"></i>
        </button>
      )}
    </div>
  );
};

export default NavigationButtons;
